import { render, staticRenderFns } from "./kdQualitySolutionMaterialAudit.vue?vue&type=template&id=28e06ed4&scoped=true"
import script from "./kdQualitySolutionMaterialAudit.vue?vue&type=script&setup=true&lang=js"
export * from "./kdQualitySolutionMaterialAudit.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e06ed4",
  null
  
)

export default component.exports